/** @format */

import { AvsRequest, AvsResponse } from '@cart-checkout/checkout/data-access/interfaces';

import { AvsDao } from 'libs/cart-checkout/checkout/data-access/dao/src/lib/avs.dao';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class AvsService {
	constructor(private avsDao: AvsDao) {}

	/**
	 * @param {{} | {addressLines: string[], city: string, state: string, zipcode: string, country: string}} unverifiedAddress - User entered un-verified address
	 * @returns {Observable<AvsResponse>}
	 *
	 * @description
	 * Function that calls the Shipping AVS API.  This coarse-grain API can accept an empty Object {}, or
	 * an Object with User address {'addressLines': 'STRING[]', 'city': 'STRING', 'state': 'STRING', 'zipcode': 'STRING', 'country': 'STRING' }.
	 */
	public verifyAddress$ = (
		address,
		orderNum: string = null,
		formType: string = null
	): Observable<AvsResponse> => {
		const avsRequest: AvsRequest = {
			unverifiedAddress: {
				addressLines: address?.address2
					? [address?.address, address?.address2]
					: [address?.address],
				city: '',
				state: '',
				zipCode: address?.zipcode,
				country: ''
			},
			referenceCode: orderNum,
			originIdentifier: 'MYACCOUNT-UI'
		};

		// Make the DAO Request to fire HTTPS call to AVS service.
		return this.avsDao.verifyAddress$(avsRequest).pipe(
			map((response: AvsResponse) => {
				response.formType = formType;
				// Return the raw data
				return response;
			})
		);
	};

	/**
	 * @param {{} | {addressLines: string[], city: string, state: string, zipcode: string, country: string}} unverifiedAddress - User entered un-verified address
	 * @returns {Observable<AvsResponse>}
	 *
	 * @description
	 * Function that calls the new AVS v2 API.
	 */
	public verifyAddressV2$ = (
		address,
		orderNum: string = null,
		formType: string = null
	): Observable<AvsResponse> => {
		const avsRequest: AvsRequest = {
			unverifiedAddress: {
				addressLines: address?.address2
					? [address?.address, address?.address2]
					: [address?.address],
				city: '',
				state: '',
				zipCode: address?.zipcode,
				country: ''
			},
			referenceCode: orderNum
		};

		return this.avsDao.verifyAddressV2$(avsRequest).pipe(
			map((response: AvsResponse) => {
				response.formType = formType;
				return response;
			})
		);
	};
}
